import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { FooterSticky } from '~/components'
import { Button, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { selectTotalQuantity, totalMoneyItemsCartSelector } from '~/redux/cartSlice'
import { path } from '~/routes/path'
import { convertPrice } from '~/utils'
import { marginX } from '~/constants'
import { variantStyles } from '~/theme/constants'
import { selectRestaurant } from '~/redux/restaurantSlice'

const FooterCart = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const totalNumberItemsCart = useSelector(selectTotalQuantity) // Tổng số lượng item
  const totalMoneyItemsCart = useSelector(totalMoneyItemsCartSelector) // Tổng tiền của các item
  const { food_court_id } = useSelector(selectRestaurant)

  const isDisabledCart = totalNumberItemsCart === 0

  /**
   * Di chuyển đến màn hình Ordering xảy ra 2 trường hợp:
   * 1. Trường hợp nhà hàng thuộc food court -> Di chuyển đến màn hình OrderingFoodCourt
   * 2. Trường hợp còn lại -> Di chuyển đến màn hình Ordering bình thường
   */
  const gotoOrderingScreen = () => {
    if (food_court_id) {
      navigate(path.orderingFoodCourt)
    } else {
      navigate(path.ordering)
    }
  }

  return (
    <FooterSticky>
      <Button
        disabled={isDisabledCart}
        variant={variantStyles.btnOrder}
        sx={styles.btnSubmit}
        onClick={gotoOrderingScreen}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <Typography
              component="div"
              color="baseColor.colorText1"
              padding="1px 12px"
              marginRight="10px"
              borderRadius="5px"
              fontWeight="600"
              fontSize="2rem"
              sx={{
                backgroundColor: 'baseColor.colorText2',
              }}>
              {totalNumberItemsCart}
            </Typography>
            <Typography fontSize="2rem" color="baseColor.colorText3" fontWeight="700">
              {t('actions.order_now')}
            </Typography>
          </Box>
          <Typography
            fontSize="1.8rem"
            fontWeight="400"
            lineHeight="2"
            color={'baseColor.colorText2'}>
            {convertPrice(totalMoneyItemsCart)}
          </Typography>
        </Box>
      </Button>
    </FooterSticky>
  )
}

export default React.memo(FooterCart)
FooterCart.propTyeps = {}

const styles = {
  btnSubmit: {
    width: '100%',
    marginX: `${marginX}px`,
    display: 'block',
    padding: '10px 12px',
  },
}
